// Contenuti delle pagine del marchio proprietario KTEK (linee PRO e SMART).
// Testi ripresi dal documento "DTK_Contenuti_Web_SEO_v1" fornito dall'utente.
import ktekLineupImg from '../assets/ktek/ktek_lineup.png';
import ktekProImg from '../assets/ktek/ktek_pro.png';
import ktekSmartImg from '../assets/ktek/ktek_smart.png';

export interface KtekLine {
  slug: 'pro' | 'smart';
  label: string;
  seoTitle: string;
  metaDescription: string;
  heading: string;
  intro: string;
  targetTitle: string;
  target: string[];
  benefitsTitle: string;
  benefits: string[];
  image: string;
  accentColor: string;
  positioning: string;
  priority: string;
  promise: string;
}

export const KTEK_LINES: KtekLine[] = [
  {
    slug: 'pro',
    label: 'KTEK PRO',
    seoTitle: 'KTEK PRO: toner compatibili ad alte prestazioni | DTK',
    metaDescription: 'KTEK PRO è la linea di toner e componenti compatibili per alte prestazioni, utilizzi intensivi e continuità operativa professionale.',
    heading: 'KTEK PRO: prestazioni professionali, stampa dopo stampa.',
    intro: 'KTEK PRO è la linea di fascia superiore, sviluppata per chi cerca prestazioni elevate, affidabilità e continuità anche negli utilizzi più intensivi. I prodotti della linea PRO sono selezionati per offrire qualità di stampa uniforme, stabilità durante l\'intero ciclo di utilizzo e prestazioni affidabili negli ambienti professionali.',
    targetTitle: 'Per chi è pensata',
    target: ['Rivenditori che desiderano continuità e qualità professionale', 'Applicazioni nelle quali l\'affidabilità rappresenta un requisito prioritario'],
    benefitsTitle: 'Perché scegliere KTEK PRO',
    benefits: ['Prestazioni elevate', 'Qualità di stampa costante', 'Affidabilità nei volumi di lavoro più intensivi', 'Componenti accuratamente selezionati', 'Alternativa professionale ai prodotti originali', 'Supporto e competenza DTK'],
    image: ktekProImg,
    accentColor: '#1E3A5F',
    positioning: 'Prestazioni professionali',
    priority: 'Continuità, stabilità e qualità',
    promise: 'Performance you can trust',
  },
  {
    slug: 'smart',
    label: 'KTEK SMART',
    seoTitle: 'KTEK SMART: toner e consumabili compatibili convenienti | DTK',
    metaDescription: 'KTEK SMART è la linea di toner e consumabili compatibili pensata per ridurre il costo di stampa e offrire affidabilità nell\'uso quotidiano.',
    heading: 'KTEK SMART: prestazioni intelligenti, costi sotto controllo.',
    intro: 'KTEK SMART è la linea pensata per chi desidera contenere i costi di stampa senza rinunciare all\'affidabilità necessaria per il lavoro quotidiano. Una scelta semplice e conveniente, adatta agli utilizzi standard e a chi cerca un corretto equilibrio tra prestazioni e prezzo.',
    targetTitle: 'Per chi è pensata',
    target: ['Piccoli uffici e attività commerciali', 'Rivenditori alla ricerca di una proposta competitiva', 'Clienti particolarmente attenti al costo per pagina', 'Applicazioni nelle quali la convenienza rappresenta il principale criterio di scelta'],
    benefitsTitle: 'Perché scegliere KTEK SMART',
    benefits: ['Prezzo competitivo', 'Affidabilità nell\'utilizzo quotidiano', 'Buona qualità di stampa', 'Compatibilità verificata', 'Riduzione dei costi di gestione', 'Selezione e supporto DTK'],
    image: ktekSmartImg,
    accentColor: '#0F766E',
    positioning: 'Convenienza intelligente',
    priority: 'Costo per pagina e affidabilità',
    promise: 'Smart choice. Reliable prints. Great value.',
  },
];

export const KTEK_LINEUP_IMAGE = ktekLineupImg;
